/*eslint consistent-this:0*/

var m = require('am');
import log from 'rawr/utils/log';
import hash from 'rawr/utils/hash';

m.factory('debounce', ['$timeout', function($timeout) {
  return function(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      $timeout.cancel(timeout);
      timeout = $timeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };
}]);

m.factory('throttle', ['$timeout', function($timeout) {
  return function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : new Date();
      timeout = null;
      result = func.apply(context, args);
    };
    return function() {
      var now = new Date();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0) {
        $timeout.cancel(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
      } else if (!timeout && options.trailing !== false) {
        timeout = $timeout(later, remaining);
      }
      return result;
    };
  };
}]);

m.factory('Modernizr', ['$window', function($window) {
  return $window.Modernizr;
}]);

m.directive('delayActive', ['$timeout', function($timeout) {
  return {
    link: function(scope, element, attrs) {
      $timeout(function() {
        element.addClass('active');
      }, attrs.delayActive);
    }
  };
}]);

m.filter('pprint', function() {
  return function(input) {
    return angular.toJson(input, true);
  };
});

m.filter('plaintext', function() {
  return function(text) {
    return text && text.replace(/<[^>]+>/gm, ' ');
  };
});

m.filter('linebreaks', function() {
  return function(string, num) {
    return string.split('\n').slice(0, num).join('\n');
  };
});

m.filter('words', function() {
  return function(string, num, follower) {
    return string.split(' ').slice(0, num).join(' ') + (follower || '...');
  };
});

m.filter('depipe', function() {
  return function(text) {
    return text && text.replace(/ ?\|\| ?/g, ' ');
  };
});

m.filter('round', function() {
  return function(num, places, fixed) {
    var rounded;
    if (!places) {
      rounded = Math.round(num);
    } else {
      var amount = Math.pow(10, places);
      rounded = Math.round(num * amount) / amount;
    }
    return fixed ? rounded.toFixed(places || 0) : rounded;
  };
});

m.factory('static_url', ['config', function(config) {
  return function(url) {
    return config.static_url + url;
  };
}]);

m.run(['$rootScope', 'static_url', function($rootScope, static_url) {
  $rootScope.static = static_url;
}]);

m.factory('hash', function() {
  return hash;
});

m.config(['$provide', function($provide) {
  $provide.decorator('$log', ['$delegate', function($delegate) {
    ['debug', 'log', 'info', 'warn', 'error'].forEach(function(n) {
      $delegate[n] = collector(n);
      // Prevent angular-mocks from choking.
      $delegate[n].logs = [];
    });

    function collector(log_name, cap) {
      var logger = $delegate[log_name];
      return function(message) {
        log.collect(log_name, message);
        if (log_name !== 'debug') {
          return logger(message);
        }
      };
    }
    return $delegate;
  }]);
}]);

m.directive('dynSref', ['$state', function($state){
  return {
    restrict: 'A',
    link: function($scope, $elem, $attr){
      $scope.$watch(function() {
        var sref = $scope.$eval($attr.dynSref);
        return sref && $state.href.apply($state, sref);
      }, function(href){
        $elem.attr('href', href || '');
      }, true);
    }
  };
}]);

m.factory('naturalKey', function() {
  function replace(m) {
    return '0000000'.substr(m.length - 1) + m;
  }
  function make(input) {
    return input.replace(/\d+/g, replace);
  }
  return function(field) {
    if (field) {
      return function(obj) {
        return make(obj[field]);
      };
    } else {
      return function(input) {
        return make(input);
      };
    }
  };
});

_.each({includes: 'dynSrefInherited', is: 'dynSrefActive'}, function(attr, matcher) {
  m.directive(attr, ['$state', function($state){
    return {
      restrict: 'A',
      link: function($scope, $elem, $attr){
          $scope.$watch(function() {
            var sref = $scope.$eval($attr.dynSref);
            return $state[matcher](sref[0], _.mapValues(sref[1], function(v){
              try {
                return v.toString();
              } catch (e) {
                return v;
              }
            }));
          }, function(active){
            if (active) {
              $elem.addClass($attr[attr]);
            } else {
              $elem.removeClass($attr[attr]);
            }
          });
      }
    };
  }]);
});

m.directive('autofillCheck', ['$interval', function($interval){
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function($scope, $elem, $attr, ngModel){
      var stop = $interval(function() {
        if ($elem.val() && $elem.val() !== ngModel.$viewValue) {
          ngModel.$setViewValue($elem.val());
        }
      }, 250);
      $scope.$on('$destroy', function() {
        $interval.cancel(stop);
      });
    }
  };
}]);

m.directive('scrollTop', ['$window', function($window){
  return {
    restrict: 'A',
    link: function($scope, $elem, $attr){
      $elem.on('click', function(){
        $window.scrollTo(0,0);
      });
    }
  };
}]);



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/Utils.js
 **/